<template>
    <div class="about">
        <div class="top-actions">
            <el-button type="default" size="small" icon="el-icon-refresh" @click="handleRefresh"></el-button>
            <el-button type="default" size="small" icon="el-icon-download" @click="handleExport">导出</el-button>
            <el-button type="danger" size="small" icon="el-icon-delete" @click="handleDeleteSelected">删除</el-button>

            <div class="search-container">
                <el-input placeholder="搜索" v-model="searchQuery" suffix-icon="el-icon-search" @input="handleSearch"></el-input>
                <el-button type="default" icon="el-icon-search" @click="showSearchFields = !showSearchFields"></el-button>
            </div>
        </div>
        <div v-if="showSearchFields" class="advanced-search-fields">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form :model="searchForm" label-width="100px">
                        <el-form-item label="任务ID">
                            <el-input v-model="searchForm.taskId" placeholder="请输入任务ID"></el-input>
                        </el-form-item>
                        <el-form-item label="任务名">
                            <el-input v-model="searchForm.taskName" placeholder="请输入任务名"></el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="12">
                    <el-form :model="searchForm" label-width="100px">
                        <el-form-item label="采集源">
                            <el-input v-model="searchForm.collectionSource" placeholder="请输入采集源"></el-input>
                        </el-form-item>
                        <el-form-item label="创建时间">
                            <el-date-picker
                                v-model="searchForm.creationTime"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-button type="primary" @click="handleAdvancedSearch">提交</el-button>
            <el-button type="default" @click="showSearchFields = false">取消</el-button>
        </div>

        <el-table
            ref="filterTable"
            :data="paginatedTableData"
            :header-cell-style="{color:'#606266',background:'#f5f7fa'}"
            style="width: 100%"
            stripe
            border
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="user_id" label="任务ID" sortable width="180"></el-table-column>
            <el-table-column prop="source_keyword" label="任务名" width="180"></el-table-column>
             <!--  <el-table-column prop="create_time" label="发布时间"></el-table-column> -->
            <el-table-column prop="create_time" label="采集时间"></el-table-column>
            <el-table-column prop="title" label="视频标题"></el-table-column>
            <el-table-column prop="video_url" label="视频链接"></el-table-column>
            <el-table-column prop="video_comment" label="线索数"></el-table-column>
            <el-table-column prop="video_comment" label="评论筛选数"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination">
            <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="currentPage"
                :page-sizes="[50, 100, 200]"
                :page-size="pgSize"
                :total="filteredTableData.length"
                @size-change="handleSizeChange"
                @current-change="handlePageChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { bilibili_video, bilibili_video2, bilibili_video3, bilibili_video4,bilibili_video8, delete_bilibili_video } from '@/api/bili';
import moment from 'moment';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default {
    data() {
        return {
            currentPage: 1,       // 当前页码
            pgSize: 50,           // 每页显示50条
            idx: -1,
            editVisible: false,
            form: {},
            searchQuery: '',      // 简单搜索关键词
            showSearchFields: false, // 是否显示高级搜索
            searchForm: {
                taskId: '',
                taskName: '',
                collectionSource: '',
                creationTime: ''
            },
            selectedRows: [],     // 选中的行
            tableData: []         // 表格数据
        }
    },
    computed: {
        // 过滤后的数据（包含搜索和高级搜索）
        filteredTableData() {
            let data = [...this.tableData];
            
            // 简单搜索
            if (this.searchQuery) {
                const query = this.searchQuery.toLowerCase();
                data = data.filter(item => 
                    Object.values(item).some(value => 
                        String(value).toLowerCase().includes(query)
                    )
                );
            }
            
            // 高级搜索
            if (this.searchForm.taskId) {
                data = data.filter(item => 
                    String(item.user_id).includes(this.searchForm.taskId)
                );
            }
            
            if (this.searchForm.taskName) {
                data = data.filter(item => 
                    item.source_keyword.toLowerCase().includes(this.searchForm.taskName.toLowerCase())
                );
            }
            
            if (this.searchForm.collectionSource) {
                data = data.filter(item => 
                    String(item.collectionSource).toLowerCase().includes(this.searchForm.collectionSource.toLowerCase())
                );
            }
            
            if (this.searchForm.creationTime) {
                const date = this.searchForm.creationTime;
                data = data.filter(item => 
                    moment(item.create_time).format('YYYY-MM-DD') === date
                );
            }
            
            return data;
        },
        // 分页后的数据
        paginatedTableData() {
            const start = (this.currentPage - 1) * this.pgSize;
            const end = start + this.pgSize;
            return this.filteredTableData.slice(start, end);
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
        // 根据用户角色获取对应的API
        getApiByRole() {
            const userRole = localStorage.getItem('userRole') || 'admin';
            
            const apiMap = {
                'admin': bilibili_video,
                'manager': bilibili_video2,
                'zhuzhu': bilibili_video3,
                'huolong': bilibili_video3,
                'buzhi': bilibili_video3,
                'ruiqi': bilibili_video3,
                'daolai': bilibili_video3,
                'yangguang': bilibili_video3,
                'demo': bilibili_video3,
                'jinlianan': bilibili_video3,
                'jinlianan2': bilibili_video3,
                'jinlianan2': bilibili_video3,
                'dianguang1': bilibili_video3,
                'dianguang2': bilibili_video3,
                'dianguang3': bilibili_video3,
                'demo': bilibili_video8,
                

            };
            
            return apiMap[userRole] || bilibili_video;
        },
        // 获取表格数据
        fetchData() {
            const api = this.getApiByRole();
            api({ task_id: this.$route.query.task_id }).then(response => {
                // 假设API返回的数据结构如下，根据实际情况调整
                this.tableData = response.data.map(item => ({
                    user_id: item.user_id,
                    source_keyword: item.source_keyword, 
                    create_time: item.create_time, 
                    title: item.title, 
                    video_url: item.video_url,
                    video_comment: item.video_comment,
                    // 如果有collectionSource字段，请确保API返回该字段
                    collectionSource: item.collection_source || '', // 根据实际字段名调整
                }));
            }).catch(error => {
                console.error('获取数据时出错！', error);
                this.$message.error('获取数据失败');
            });
        },
        // 导出选中的行
        getExportFileName() {
            const date = this.$route.query.order_date;
            const amount = this.$route.query.order_amount;
            return date && amount ? `${date}-${Number(amount)}.xlsx` : `任务${this.$route.query.task_id || '数据'}.xlsx`;
        },
        handleExport() {
            if (this.selectedRows.length === 0) {
                this.$message.warning('请先选择要导出的行！');
                return;
            }

            const dataToExport = this.selectedRows.map(item => {
                const user_id = item.user_id;
                const homepageUrl = `https://www.bilibili.com/video/${user_id}`; // 假设B站视频链接格式
                return {
                    "任务ID": item.user_id,
                    "任务名": item.source_keyword,
                    "发布时间": this.formatDate(item.create_time),
                    "采集时间": this.formatDate(item.create_time),
                    "视频标题": item.title,
                    "视频链接": homepageUrl, // 根据实际情况调整
                    "线索数": item.video_comment,
                    "评论筛选数": item.video_comment,
                };
            });

            const worksheet = XLSX.utils.json_to_sheet(dataToExport);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

            const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([wbout], { type: "application/octet-stream" });
            saveAs(blob, this.getExportFileName());
        },
        // 刷新表格数据
        handleRefresh() {
            this.fetchData();
        },
        // 复制主页链接（快手组件中的功能，B站可能不需要，可根据需要保留或删除）
        handleCopyHomepage(row) {
            // B站视频通常没有个人主页链接，可根据实际情况调整
            this.$message.info('B站视频暂无个人主页链接');
        },
        // 提交高级搜索
        handleAdvancedSearch() {
            this.currentPage = 1; // 重置到第一页
            this.showSearchFields = false;
        },
        // 删除选中的行
        handleDeleteSelected() {
            if (this.selectedRows.length === 0) {
                this.$message.warning('请先选择要删除的行！');
                return;
            }

            const userIds = this.selectedRows.map(row => row.user_id);
            this.$confirm('确定要删除选中的记录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                Promise.all(userIds.map(id => delete_bilibili_video(id)))
                    .then(() => {
                        this.$message.success('删除成功');
                        this.fetchData(); // 刷新数据
                        this.selectedRows = []; // 清空选中项
                    })
                    .catch(error => {
                        this.$message.error('部分删除失败');
                        console.error('批量删除时出错！', error);
                    });
            }).catch(() => {});
        },
        // 删除单行
        handleDelete(index, row) {
            this.$confirm('确定要删除这条记录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delete_bilibili_video(row.user_id).then(() => {
                    this.$message.success('删除成功');
                    this.fetchData(); // 刷新数据
                }).catch(error => {
                    this.$message.error('删除失败');
                    console.error('删除时出错！', error);
                });
            }).catch(() => {});
        },
        // 处理页码变化
        handlePageChange(val) {
            this.currentPage = val;
        },
        // 处理每页显示数量变化
        handleSizeChange(val) {
            this.pgSize = val;
            this.currentPage = 1; // 重置到第一页
        },
        // 处理选中行变化
        handleSelectionChange(selection) {
            this.selectedRows = selection;
        },
        // 格式化日期
        formatDate(dateString) {
            if (!dateString) return '';
            return moment(dateString).format('YYYY-MM-DD HH:mm:ss');
        },
        // 简单搜索
        handleSearch() {
            this.currentPage = 1; // 搜索后重置到第一页
            // filteredTableData 已经在计算属性中处理，无需额外操作
        }
    }
}
</script>

<style lang="stylus">
.top-actions
    display flex
    align-items center
    justify-content space-between
    margin-bottom 10px

.search-container
    margin-left: auto

.button-container
    margin-right: auto

.advanced-search-fields {
    margin-bottom: 10px;
}


</style>
